import classNames from "classnames";
import React from "react";
import { Link } from "../";
import { useClasses, Col, Row } from "..";
const styles = (theme) => ({
    link: {
        display: "block",
        padding: "8px 16px",
        margin: "0px -16px",
        fontSize: "1.1rem",
        color: theme.palette.get("grey"),
        textDecoration: "none",
        "&:hover": {
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
    },
    active: {
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
});
export default function SidebarLink(props) {
    const classes = useClasses(styles);
    const { active } = props;
    return (React.createElement(Link, { to: props.to, className: classNames([classes.link, active && classes.active]), onClick: props.onClick },
        React.createElement(Row, null,
            React.createElement(Col, { xs: "28px" }, props.icon),
            React.createElement(Col, { xs: "rest-fixed" }, props.children))));
}
